// src/config/whatsappGroups.ts
export const whatsappGroups = {
  jobs: {
    title: 'Job Opportunities',
    description: 'Stay updated with latest job postings and career opportunities',
    groups: [
      {
        id: 'All Job Updates',
        title: 'All Job Updates',
        description: 'General job opportunities across all industries',
        metadata: {
          members: '150+',
          category: 'General Jobs',
          updateFrequency: 'Daily',
          featured: ['Job alerts', 'Career tips', 'Interview prep']
        },
        buttonText: 'Tap here to join',
        url: 'https://whatsapp.com/channel/0029VbCYIjeLY6dAfJRQVd15',
      },
      {
        id: 'Marketing Jobs Updates',
        title: 'Marketing Jobs Updates',
        description: 'Exclusive marketing job postings and opportunities',
        metadata: {
          members: '550+',
          category: 'Marketing Jobs',
          updateFrequency: 'Daily',
          featured: ['Marketing roles', 'Digital marketing jobs', 'Senior positions']
        },
        buttonText: 'Tap here to join',
        url: 'https://chat.whatsapp.com/IMdICoxYov8AgCRdYxGmGL?mode=gi_t',
      },
    ],
  },
  training: {
    title: 'Tips & Training',
    description: 'Access exclusive marketing tips, training updates, and resources',
    groups: [
      {
        id: 'Janet Marketing Tips & Training',
        title: 'Janet Marketing Tips & Training',
        description: 'Daily marketing strategies, tips, and professional development',
        metadata: {
          members: '3k+',
          category: 'Marketing Tips & Training',
          updateFrequency: 'Daily',
          featured: ['Marketing strategies', 'Training modules', 'Industry insights', 'Success stories']
        },
        buttonText: 'Tap here to join',
        url: 'https://whatsapp.com/channel/0029Vay5vuYJP20zZ2AeBg2y',
      },
    ],
  },
};

export default whatsappGroups;
